import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PromotionsService } from '../services';
import { getPromotionsQueryKey } from './useGetPromotions';

export const useUpdatePromotion = (options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalErrorToaster: true },
    mutationFn: ({ promotionId, changes }) =>
      PromotionsService.updatePromotion(promotionId, changes),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: getPromotionsQueryKey() });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
